import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography } from '@mui/material';
import PeopleOutlineRoundedIcon from '@mui/icons-material/PeopleOutlineRounded';

import colors from '../../../../../styles/colors';
import SectionCard from '../../components/SectionCard';
import { formatRecipientCount } from '../../utils/formatRecipientCount';
import { EM_DASH } from '../../utils/constants';
import texts from '../../texts.json';

const RecipientsCard = ({
  count,
  loading,
  error,
  capped,
  coachName,
}) => {
  let display;
  if (error) display = EM_DASH;
  else if (loading) display = texts.sidePanel.recipientsLoading;
  else display = formatRecipientCount(count, capped);

  return (
    <SectionCard>
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Stack flex={1} spacing={0.5}>
          <Typography variant="overline" fontWeight={700} color="text.secondary">
            {texts.sidePanel.recipientsLabel}
          </Typography>
          <Typography
            variant="h4"
            fontWeight={700}
            color={error ? 'error' : colors.shades.beta2}
            sx={{ lineHeight: 1 }}
          >
            {display}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {error ? texts.sidePanel.recipientsError : (coachName || EM_DASH)}
          </Typography>
        </Stack>
        <PeopleOutlineRoundedIcon sx={{ fontSize: 28, color: 'text.secondary' }} />
      </Stack>
    </SectionCard>
  );
};

RecipientsCard.propTypes = {
  count: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  capped: PropTypes.bool,
  coachName: PropTypes.string,
};

RecipientsCard.defaultProps = {
  loading: false, error: false, capped: false, coachName: '',
};

export default RecipientsCard;
